import { createSelector } from 'reselect'
// import { List } from 'immutable'

const teamSelector = state => state.get('team')

export const getIsFetching = createSelector(
  teamSelector,
  teamImmutable => {
    const team = teamImmutable.toJS()
    return team.teamCreate.isFetching
    || team.teamEdit.isFetching
    || team.teamDeactivate.isFetching
    || team.teamGet.isFetching
    || team.teamList.isFetching
    || team.teamExport.isFetching
  }
)
export const getCreateTeamData = createSelector(
  teamSelector,
  teamImmutable => {
    const team = teamImmutable.toJS()
    return team.teamCreate
  }
)
export const getEditTeamData = createSelector(
  teamSelector,
  teamImmutable => {
    const team = teamImmutable.toJS()
    return team.teamEdit
  }
)
export const getDeactivateTeamData = createSelector(
  teamSelector,
  teamImmutable => {
    const team = teamImmutable.toJS()
    return team.teamDeactivate
  }
)
export const getGetTeamData = createSelector(
  teamSelector,
  teamImmutable => {
    const team = teamImmutable.toJS()
    return team.teamGet.team
  }
)
export const getListTeam = createSelector(
  teamSelector,
  teamImmutable => {
    const team = teamImmutable.toJS()
    return team.teamList.team || []
  }
)
export const getExportURL = createSelector(
  teamSelector,
  teamImmutable => {
    const team = teamImmutable.toJS()
    return team.teamExport.url
  }
)
export const redirectTeam = createSelector(
  teamSelector,
  teamImmutable => {
    const team = teamImmutable.toJS()
    return ({
      redirect: (team.teamCreate.redirect
      || team.teamEdit.redirect
      || team.teamDeactivate.redirect
      || team.teamGet.redirect
      || team.teamList.redirect
      || team.teamExport.redirect),
      isAuthenticated: (team.teamCreate.isAuthenticated
      || team.teamEdit.isAuthenticated
      || team.teamDeactivate.isAuthenticated
      || team.teamGet.isAuthenticated
      || team.teamList.isAuthenticated
      || team.teamExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/team/team-selector.js